import { render, staticRenderFns } from "./BlockBlog.vue?vue&type=template&id=0eac42e4&"
import script from "./BlockBlog.vue?vue&type=script&lang=js&"
export * from "./BlockBlog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports